import { Component } from '@angular/core';

@Component({
  selector: 'app-life-at-ketto',
  templateUrl: './life-at-ketto.component.html',
  styleUrls: ['./life-at-ketto.component.scss']
})
export class LifeAtKettoComponent {

  constructor() { }
}
